import { Map } from "immutable";
import Widget from "views/logic/widgets/Widget";
import isDeepEqual from "stores/isDeepEqual";
import isEqualForSearch from "views/stores/isEqualForSearch";
import InvestigationsWidgetConfig from "./InvestigationsWidgetConfig";
const _InvestigationsWidget = class _InvestigationsWidget extends Widget {
  constructor(id, config, description, context) {
    super(id, _InvestigationsWidget.type, config, null, null, null, [], [], void 0, description, context);
  }
  // eslint-disable-next-line class-methods-use-this
  get returnsAllRecords() {
    return true;
  }
  static fromJSON(value) {
    const { id, config, description, context } = value;
    return new _InvestigationsWidget(id, InvestigationsWidgetConfig.fromJSON(config), description, context);
  }
  equals(other) {
    if (other instanceof _InvestigationsWidget) {
      return ["id", "config"].every((key) => isDeepEqual(this[key], other[key]));
    }
    return false;
  }
  equalsForSearch(other) {
    if (other instanceof _InvestigationsWidget) {
      return ["id", "config"].every((key) => isEqualForSearch(this[key], other[key]));
    }
    return false;
  }
  toBuilder() {
    const { id, config, description, context } = this._value;
    return new Builder(Map({ id, config, description, context }));
  }
  static builder() {
    return new Builder();
  }
};
_InvestigationsWidget.type = "investigations";
_InvestigationsWidget.defaultTitle = "Untitled Investigations Overview";
let InvestigationsWidget = _InvestigationsWidget;
export {
  InvestigationsWidget as default
};
class Builder extends Widget.Builder {
  build() {
    const { id, config, description, context } = this.value.toObject();
    return new InvestigationsWidget(id, config, description, context);
  }
}
